module.exports = __webpack_public_path__ + "img/w40b.78383bdd.jpg";